import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLinkWithHref } from '@angular/router';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FavoritesBtnComponent } from './buttons/favorites-btn.component';
import { SelfOffersBtnComponent } from './buttons/selfoffers-btn.component';

@Component({
  selector: 'ra-user-space',
  standalone: true,
  imports: [
    CommonModule,
    OverlayPanelModule,
    SharedModule,
    ButtonModule,
    RouterLinkWithHref,
    FavoritesBtnComponent,
    SelfOffersBtnComponent,
  ],
  templateUrl: './user-space.component.html',
  styleUrls: ['./user-space.component.scss'],
})
export class UserSpaceComponent {}
